import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import { getScheduleVariantsList, deleteScheduleVariant, setYear } from '../../actions/scheduleVariants'
import { Select } from '../../components/ModalInputs'
import Table from '../../components/Table'
import { getSchoolYears } from '../../actions/common'
import Confirmation from '../../components/Confirmation/Confirmation'
import TrashButton from '../../components/TrashButton'


export default function ScheduleVariants() {

  const dispatch = useDispatch()
  const { list, year } = useSelector(state => state.schedule_variants)
  const { schoolYears } = useSelector(state => state.common)

  const [selectedItem, setSelectedItem] = useState(null)
  const [variantForDelete, setVariantForDelete] = useState(null)
  const [filters, setFilters] = useState(null)

  const handleFilters = (filter) => {
    setFilters(prev => ({ ...prev, ...filter }))
  }

  useEffect(() => {
    dispatch(getSchoolYears())
    return () => dispatch(setYear(''))
  }, [])

  useEffect(() => {
    dispatch(getScheduleVariantsList())
  }, [year])

  const openModal = (data) => () => setSelectedItem(data || {})
  const closeModal = () => setSelectedItem(null)

  const sortedList = useMemo(() => {
    if (!list) return []
    if (!filters?.sort_key) return list
    return [...list].sort((a, b) => {
      const aVal = String(a[filters.sort_key] ?? '')
      const bVal = String(b[filters.sort_key] ?? '')
      return filters.sort_order
        ? aVal.localeCompare(bVal, 'ru')
        : bVal.localeCompare(aVal, 'ru')
    })
  }, [list, filters])

  const renderLi = (data) => {
    const { sh_var_id, year_name, sh_var_name, sh_var_comments } = data
    return (
      <tr key={sh_var_id} onClick={openModal(data)}>
        <td>{year_name}</td>
        <td>{sh_var_name}</td>
        <td>{sh_var_comments || <span className={styles.dash}>—</span>}</td>
        <td><TrashButton onClick={deleteClickHandler(data)} /></td>
      </tr>
    )
  }

  const deleteClickHandler = (variant) => (e) => {
    e.stopPropagation()
    setVariantForDelete(variant)
  }

  const acceptConfirm = () => {
    dispatch(deleteScheduleVariant(variantForDelete.sh_var_id))
    setVariantForDelete(null)
  }

  const rejectConfirm = () => setVariantForDelete(null)

  return (
    <div className={styles.wrapper}>
      {variantForDelete &&
        <Confirmation
          title={`Вы уверены, что хотите удалить вариант ${variantForDelete.sh_var_name}?`}
          acceptConfirmation={acceptConfirm}
          rejectConfirmation={rejectConfirm}
        />
      }
      <Modal
        closeModal={closeModal}
        data={selectedItem}
        yearId={year}
        schoolYears={schoolYears}
      />
      <header className={styles.header}>
        <h1>Варианты расписания</h1>
      </header>
      <main className={styles.content}>
        <Select
          label='Учебный год'
          value={year}
          onChange={(e) => dispatch(setYear(e.target.value))}
        >
          <option value=''>Все</option>
          {schoolYears?.map(({ name, xp_key }) => <option key={xp_key} value={xp_key}>{name}</option>)}
        </Select>
        <div className={styles.tablecard}>
          {sortedList.length ? (
            <Table className={styles.table} maxHeight='calc(100vh - 380px)'>
              <thead>
                <tr>
                  <th style={{ cursor: 'pointer' }} onClick={() => handleFilters({ sort_order: !filters?.sort_order, sort_key: 'year_name' })}>Уч.год</th>
                  <th style={{ cursor: 'pointer' }} onClick={() => handleFilters({ sort_order: !filters?.sort_order, sort_key: 'sh_var_name' })}>Вариант</th>
                  <th style={{ cursor: 'pointer' }} onClick={() => handleFilters({ sort_order: !filters?.sort_order, sort_key: 'sh_var_comments' })}>Комментарий</th>
                  <th>Удалить</th>
                </tr>
              </thead>
              <tbody>
                {sortedList.map(renderLi)}
              </tbody>
            </Table>
          ) : (
            <div className={styles.noData}>Вариантов нет. Нажмите «Добавить вариант».</div>
          )}
        </div>
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal()}>
            <IoIosAdd size={30} />
            Добавить вариант
          </Button>
          <span className={styles.counter}>Всего записей: {list?.length || 0}</span>
        </div>
      </main>
    </div>
  )
}
